import { AssetManager, SpineExtended } from '@game-studio/arcade-base';
import { Container } from 'pixi.js-legacy';
import { GoldState, gameModel } from '../../models/game-model';
import { ISkeletonData } from 'pixi-spine';
import { optimizationService } from '../../services/optimization-service';

export class InstantPrizeIndicatorView extends Container {
    private _indicatorSpine: SpineExtended;

    constructor() {
        super();
        // Create spine asset.
        const spineData: ISkeletonData = AssetManager.getSpineResourceData('phone');
        this._indicatorSpine = new SpineExtended(spineData);
        this.addChild(this._indicatorSpine);

        // Setup spine state.
        this._indicatorSpine.state.setAnimation(0, 'idle', true);
        optimizationService.optimizeOn(this._indicatorSpine);

        // Add bindings and listeners.
        this.addListeners();
    }

    private onGoldState$(): void {
        if (gameModel.goldState === GoldState.TRANS_ON) {
            optimizationService.optimizeOff(this._indicatorSpine);
            this._indicatorSpine.setAnimationPromise('lightsOn').then(() => {
                this._indicatorSpine.stateData.setMix('lightsOn', 'lightsLoop', 0.5);
                this._indicatorSpine.state.setAnimation(1, 'phoneRing', true);
                gameModel.goldState = GoldState.LOOP;
            });
        }

        if (gameModel.goldState === GoldState.TRANS_OFF) {
            this._indicatorSpine.setAnimationPromise('idle', { trackIndex: 1 }).then(() => {
                this._indicatorSpine.setAnimationPromise('lightsOff', { trackIndex: 0 }).then(() => {
                    optimizationService.optimizeOn(this._indicatorSpine);
                });
            });
        }
    }

    private addListeners(): void {
        gameModel.bindToValue(
            this,
            () => gameModel.goldState,
            () => this.onGoldState$
        );
    }
}
